// extracted by css-extract-rspack-plugin
export default {"thumb":"kLSlUC"};